import { SvgIcon } from '@/components/SvgIcon';

import { ProductCardFeatureProps } from './types';

import iconCheckSrc from '~/icons/check.svg';

type Props = {
  features: ProductCardFeatureProps[];
};
export default function ProductCardFeatures({ features }: Props) {
  return (
    <ul className='mb-6'>
      {features.map(({ id, string }) => (
        <li
          key={id}
          className='flex items-center gap-2 text-body-m text-gray-600 dark:text-gray-dark-400'
        >
          <SvgIcon src={iconCheckSrc} className='h-4 w-4 text-gray-400' />
          {string}
        </li>
      ))}
    </ul>
  );
}
